function reducer(state, action) {
  switch (action.type) {
      case "setCurIdx":
          return { ...state, curIdx: action.idx };
      default:
          throw new Error();
  }
}
export default reducer
